import { Marker } from 'react-map-gl/mapbox';

import { CenterDot } from '../../mapbox-common/styles';
import { useMapboxStore } from '../store';
import { CenterDiv } from '../styles';

export default function Center() {
  const { center, currentPlaceId, currentPlaces } = useMapboxStore();

  if (!center) return null;

  return (
    <Marker
      longitude={center.location.lng}
      latitude={center.location.lat}
      style={{ zIndex: currentPlaceId ? currentPlaces.length : 199 }}
      anchor="bottom"
    >
      <CenterDiv>{center.logo && <img src={center.logo} style={{ height: '30px' }} />}</CenterDiv>
      <CenterDot />
    </Marker>
  );
}
